<template>
  <div class="evaluate">
    <div class="banxin">
      <div class='head'>
        <router-link to="/myEvaluate">
          <div class='all'>我的评价</div>
        </router-link>
        <div class='arrow'></div>
        <div class='keyword'>追加评价</div>
      </div>
      <div class="content">
        <div class="top">
          <div class="left">
            <div class="box">
              <img :src="productData.productImage" alt="">
              <p class="name">{{productData.productName}}</p>
              <div class="price">
                <span class="currency">¥</span>
                <span class="money">{{productData.productPrice}}</span>
              </div>
              <p class="size"><span v-for="(val,idx) in productData.values" :key="idx">{{val}}</span></p>
            </div>
          </div>
          <div class="right">
            <div class="title">填写商品评价：</div>
            <el-form ref="form" label-width="80px">
              <el-form-item label="初次评价">
                <p class="mar-bot-10">{{evaluateData.comment}}</p>
                <el-rate disabled-void-color="#E5E5E5" disabled class="mar-bot-10" v-model="evaluateData.star"></el-rate>
                <p class="mar-bot-10" v-show="evaluateData.impression"><span class="font-color-FF7 tag active" v-for="(imp,inx) in impression" :key="inx">{{imp}}</span></p>
                <el-image
                  v-for="(url,ix) in evaluateData.images"
                  :key="ix"
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="images">
                </el-image>
              </el-form-item>
              <el-form-item class="additional" label="追加评价">
                <el-input
                  type="textarea"
                  placeholder="请输入您的评语"
                  v-model="text"
                  rows=5
                  resize=none
                ></el-input>
                <br>
                <el-upload
                  :action="action"
                  list-type="picture-card"
                  :limit="5"
                  :on-success="handSuccess"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="imgNum">
                  共<span class="text">{{urls.length}}</span>张，还可以上传<span class="text">{{5-(urls.length)}}</span>张
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="bottom">
          <el-button plain @click="addToComment" v-throttle>提交评价</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
export default {
  mixins: [listSearchMixin],
  data () {
    return {
      text: '',
      images: [],
      product: {},
      colors: [
        '#D22929',
        '#D22929',
        '#D22929'
      ],
      urls: [],
      dialogVisible: false,
      disabled: false,
      evaluateData: {},
      commentId: '',
      evaluateList: {},
      action: api.upload,
      productData: '',
      impression: []
    }
  },
  created () {
      this.productData = JSON.parse(this.$route.query.data)
  },
  mounted () {
      this.getEvaluateData()
  },
  methods: {
      // 获取评价详情
      getEvaluateData () {
          let self = this
          let params = {
          url: api.getEvaluateData + `?commentId=${self.productData.commentId}`,
          method: 'GET',
          data: {
          }
        }
        self.sendReq(params, (res) => {
          if (res.success) {
            self.evaluateData = res.data
            self.impression = res.data.impression.split(',')
          }
        })
      },
    // 追加评论
    addToComment () {
      if (this.text === '') {
        this.$message({
          showClose: true,
          message: '内容不能为空',
          type: 'warning'
        })
        return
      }
      let paramsData = {
          url: api.addToComment,
          method: 'PUT',
          data: {
            params: [{
              commentId: this.productData.commentId,
              image: this.urls.join(','),
              comment: this.text
            }]
          }
        }
        this.sendReq(paramsData, (res) => {
          if (res.success) {
            this.$message({
              message: '追评成功',
              type: 'success'
            })
            setTimeout(() => {
              this.$router.push('/myEvaluate')
            }, 1000)
          }
        })
    },
    // 删除上传的图片
    handleRemove (file, fileList) {
      this.urls = fileList
    },
    // 上传图片
    handSuccess (res) {
      this.urls.push(res.data.url)
    }
  }
}
</script>
<style lang = "scss" scoped>
.evaluate{
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  padding-bottom: 143px;
  text-align: center;
  .banxin{
    width: 1252px;
    margin: 0 auto;
    height: 100%;
    .head {
      width: 100%;
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .all {
        margin-right: 20px;
      }
      .keyword {
        margin: 0 20px;
        color: #D22929;
      }
      .arrow {
        background-image: url('../../../static/image/xiangyou@2x.png');
        width: 5px;
        height: 10px;
      }
    }
    .content{
      width: 100%;
      background-color: #FFFFFF;
      .top{
        width: 100%;
        display: flex;
        border-bottom: 1px solid #E5E5E5;
        .left{
          border-right: 1px solid #EAEAEA;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          .box{
            width: 260px;
            img{
              margin-bottom: 23px;
            }
            .name{
              margin-bottom: 20px;
              font-size: 14px;
            }
            .price{
              margin-bottom: 23px;
              .currency{
                font-size: 12px;
              }
              .money{
                font-size: 18px;
              }
            }
            .size{
              font-size: 12px;
              color: #999999;
              span{
                margin-right: 10px;
              }
              span:last-child{
                margin-right: 0;
              }
            }
          }
        }
        .right{
          flex: 2;
          padding: 36px 36px 0;
          box-sizing: border-box;
          .title{
            width: 100%;
            padding-bottom: 12px;
            text-align: left;
            border-bottom: 1px dashed #EAEAEA;
          }
          >>>.el-form{
              text-align: left;
              padding-top: 20px;
              .additional{
                padding-top: 22px;
                box-sizing: border-box;
                border-top: 1px dashed #E5E5E5;
              }
            .el-form-item{
              margin-bottom: 50px;
              display: flex;
              .el-form-item__label{
                flex: 1;
                text-align: left;
                color: #999999;
              }
              .el-form-item__content{
                margin-left: 10px !important;
                flex: 6;
                .el-rate{
                  transform: scale(1.4);
                  margin-left: 105px;
                }
                .tag{
                  display: inline-block;
                  width: 100px;
                  box-sizing: border-box;
                  text-align: center;
                  border: 1px solid #EAEAEA;
                  margin: 0 10px 10px 0;
                  cursor: pointer;
                }
                .active{
                  border-color: #D22929;
                }
                .el-textarea{
                  margin-bottom: 20px;
                }
                p{
                  font-size: 14px;
                }
                img{
                  width: 80px;
                  height: 80px;
                  margin-right: 15px;
                }
                .el-upload--picture-card,.el-upload-list--picture-card{
                  width: 80px;
                  height: 80px;
                  line-height: 80px;
                  .el-upload-list__item-actions,.el-upload-list__item{
                    width: 80px;
                    height: 80px;
                  }
                  i{
                    line-height: 2.1;
                  }
                  .el-icon-delete,.el-icon-zoom-in{
                    font-size: 20px;
                  }
                  .el-icon-upload-success{
                    line-height: 1;
                  }
                }
                .imgNum{
                  display: inline-block;
                  height: 60px;
                  margin-top: 20px;
                  color: #999999;
                  .text{
                    color: #D22929;
                  }
                }
              }
            }
          }
        }
      }
      .bottom{
        width: 100%;
        padding: 30px 0;
        margin-top: 2px;
        /* border-top: 1px solid #EAEAEA; */
        .el-button{
          width: 25%;
          font-size: 20px;
          background-color: #D22929;
          padding: 20px 0;
          color: #FFFFFF;
        }
      }
    }
    >>>.el-dialog{
      .el-dialog__body{
        display: flex;
        justify-content: center;
        div{
          text-align: center;
          img{
            width: 80px;
            height: 80px;
            margin-bottom: 40px;
          }
          p{
            font-size: 22px;
          }
        }
      }
      .el-dialog__footer{
        .again{
          background-color: #D22929;
          border: 1px solid #D22929;
          color: #FFFFFF;
          border-radius: 0;
        }
        .back{
          color: #D22929;
          border: 1px solid #D22929;
          background-color: #FFFFFF;
          box-sizing: border-box;
          border-radius: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/addEvaluate/index.vue